(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    // Delegated from the document, because this snippet renders many times per page while its
  // javascript block is included once. Binding per card would attach one listener per product.
  (function () {
    var STEP = '[data-qty-step]';
    var FORM = '[data-quick-add]';

    // Reveal the stepper buttons. They ship hidden so a control that cannot work is never shown:
    // without this script the number input's own spinner is the fallback.
    function revealSteppers(root) {
      var btns = (root || document).querySelectorAll(STEP + '[hidden]');
      for (var i = 0; i < btns.length; i++) btns[i].hidden = false;
    }
    revealSteppers(document);

    document.addEventListener('click', function (event) {
      var step = event.target.closest ? event.target.closest(STEP) : null;
      if (!step) return;

      var form = step.closest(FORM);
      var input = form && form.querySelector('[data-qty-input]');
      if (!input) return;

      var min = parseInt(input.getAttribute('min') || '1', 10);
      var next = (parseInt(input.value, 10) || min) + parseInt(step.getAttribute('data-qty-step'), 10);
      input.value = next < min ? min : next;
    });

    document.addEventListener('submit', function (event) {
      var form = event.target.closest ? event.target.closest(FORM) : null;
      if (!form) return;
      if (!window.fetch) return; // let the form post normally

      event.preventDefault();

      var submit = form.querySelector('.pcard__submit');
      if (submit && submit.getAttribute('aria-busy') === 'true') return;
      if (submit) submit.setAttribute('aria-busy', 'true');

      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');
          return res.json();
        })
        .then(function () {
          var card = form.closest ? form.closest('.pcard') : form;
          var originalHTML = submit ? submit.innerHTML : '';
          if (submit) {
            submit.innerHTML = '<span>[ ADDED &#10003; ]</span>';
            setTimeout(function () {
              if (submit) submit.innerHTML = originalHTML;
            }, 1200);
          }

          document.dispatchEvent(new CustomEvent('dunemark:cart-updated', {
            detail: { open: false, sourceEl: card }
          }));
        })
        .catch(function () {
          form.submit();
        })
        .then(function () {
          if (submit) submit.removeAttribute('aria-busy');
        });
    });

    document.addEventListener('change', function(event) {
      if (!event.target.classList.contains('pcard__vol')) return;
      var select = event.target;
      var option = select.options[select.selectedIndex];
      var card = select.closest('.pcard');
      if (!card) return;
      
      var priceEl = card.querySelector('.ncost__total [aria-hidden="true"]');
      var rateEl = card.querySelector('.ncost__rate');
      
      var priceVal = option.getAttribute('data-price');
      var rateVal = option.getAttribute('data-rate');

      if (priceEl && priceVal) {
        priceEl.textContent = priceVal;
      }
      if (rateEl) {
        if (rateVal && rateVal.trim().length > 0) {
          rateEl.textContent = rateVal;
          rateEl.style.display = '';
        } else {
          rateEl.style.display = 'none';
        }
      }
    });

    // Whole card click navigation
    document.addEventListener('click', function (event) {
      var card = event.target.closest ? event.target.closest('.pcard') : null;
      if (!card) return;
      if (event.target.closest('button, select, input, label, a, form, .pcard__add')) return;
      var link = card.querySelector('.pcard__link');
      if (link && link.href) {
        window.location.href = link.href;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
